export class Department {

    public id: string = "0";
    public context_id: string;
    public name: string;
    public short: string;
    public text: string;
    public deleted: boolean=false;

    constructor() {}
}